export const IncludeQcFieldName = 'includeQcFieldComponent';
